import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../../../../api';
import { FaEye, FaEyeSlash, FaCloudUploadAlt, FaTrash } from 'react-icons/fa';
import { normalizeValue } from '../../../../../utils/Texts';
import '../../../Styles/ColoresCatalog.css';

export default function ConfiguracionesSistemaModal({ open, mode, data, onClose, onSubmit, inline, triggerAlert }) {
    const [form, setForm] = useState({
        nombre: '',
        descripcion: '',
        valor: '',
        activo: true
    });
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        if (mode === 'edit' && data) {
            setForm({
                nombre: normalizeValue(data.nombre),
                descripcion: normalizeValue(data.descripcion),
                valor: normalizeValue(data.valor),
                activo: data.activo,
                showPassword: false
            });
        } else {
            setForm({
                nombre: '',
                descripcion: '',
                valor: '',
                activo: true,
                showPassword: false
            });
        }
    }, [mode, data, open]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validar extensión
        const ext = file.name.split('.').pop().toLowerCase();
        if (!['pdf', 'jpg', 'jpeg', 'png', 'webp'].includes(ext)) {
            if (triggerAlert) {
                triggerAlert('Solo se permiten archivos PDF o imágenes (JPG, PNG, WEBP).');
            } else {
                alert('Solo se permiten archivos PDF o imágenes (JPG, PNG, WEBP).');
            }
            return;
        }

        setUploading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await fetch(`${API_BASE}/upload/certificado-carrera`, {
                method: 'POST',
                body: formData
            });

            if (res.ok) {
                const json = await res.json();
                setForm(prev => ({ ...prev, valor: json.filePath }));
            } else {
                if (triggerAlert) {
                    triggerAlert('Error al subir el archivo.');
                } else {
                    alert('Error al subir el archivo.');
                }
            }
        } catch (error) {
            console.error(error);
            if (triggerAlert) {
                triggerAlert('Error al subir el archivo.');
            } else {
                alert('Error al subir el archivo.');
            }
        } finally {
            setUploading(false);
        }
    };

    const handleDeleteFile = async () => {
        if (!window.confirm('¿Estás seguro de eliminar el archivo actual?')) return;

        // Simplemente limpiamos el valor, el archivo podría quedar en S3 o borrarse
        // Si queremos borrarlo de S3, llamaríamos al endpoint delete
        setForm(prev => ({ ...prev, valor: '' }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validar límites de peso (Máximo 10GB = 10240MB)
        const weightTokens = ['LIMITE_PESO_IMAGENES', 'LIMITE_PESO_VIDEOS', 'LIMITE_PESO_DOCUMENTOS'];
        if (weightTokens.includes(form.nombre)) {
            const numericValue = parseFloat(form.valor);
            if (!isNaN(numericValue) && numericValue > 10240) {
                if (triggerAlert) {
                    triggerAlert('Por seguridad, el límite máximo permitido en la configuración es de 10240 MB (10 GB).');
                } else {
                    alert('Por seguridad, el límite máximo permitido en la configuración es de 10240 MB (10 GB).');
                }
                return;
            }
        }

        onSubmit(form, mode);
    };

    if (!open) return null;

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '0.6rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nueva Configuración' : 'Editar Configuración'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">
                ✕
            </button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '5%',
                paddingRight: 16,
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '0.8rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre (Clave):</label>
                <br /><br />
                <input
                    className="infoField"
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    required
                    maxLength={100}
                    placeholder="Ej. UrlApiExterna"
                    disabled={mode === 'edit'} // Clave no editable
                    style={{ background: mode === 'edit' ? '#f1f5f9' : 'white' }}
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
                <br /><br />
                <input
                    className="infoField"
                    name="descripcion"
                    value={form.descripcion}
                    onChange={handleChange}
                    maxLength={250}
                    placeholder="Descripción de la configuración"
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Valor:</label>
                <br /><br />
                {form.nombre === 'CORREO_NOTIFICACIONES_CLAVE' ? (
                    <div style={{ position: 'relative', width: '75%' }}>
                        <input
                            type={form.showPassword ? "text" : "password"}
                            className="infoField"
                            name="valor"
                            value={form.valor}
                            onChange={handleChange}
                            placeholder="Ingrese contraseña..."
                            style={{ paddingRight: '2.5rem', width: '100%' }}
                        />
                        <button
                            type="button"
                            onClick={() => setForm(prev => ({ ...prev, showPassword: !prev.showPassword }))}
                            style={{
                                position: 'absolute',
                                right: '0.5rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '4px',
                            }}
                            title={form.showPassword ? 'Ocultar' : 'Ver'}
                        >
                            {form.showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                        </button>
                    </div>
                ) : form.nombre === 'LMS_CERTIFICADO_CARRERA' ? (
                    <div style={{ border: '1px dashed #cbd5e1', padding: '1rem', borderRadius: '8px', background: '#f8fafc' }}>
                        {form.valor ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.9rem', color: '#0f172a' }}>
                                    <span style={{ fontWeight: 600, color: '#10b981', marginRight: '6px' }}>✓</span>
                                    Actual: <a href={form.valor} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>{form.valor.split('/').pop()}</a>
                                </div>
                                <button
                                    type="button"
                                    onClick={handleDeleteFile}
                                    style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                                    title="Eliminar archivo"
                                >
                                    <FaTrash />
                                </button>
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center' }}>
                                <input
                                    id="cert-upload"
                                    type="file"
                                    accept=".pdf,image/*"
                                    onChange={handleFileUpload}
                                    style={{ display: 'none' }}
                                    disabled={uploading}
                                />
                                <label
                                    htmlFor="cert-upload"
                                    style={{
                                        cursor: uploading ? 'wait' : 'pointer',
                                        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', color: '#64748b'
                                    }}
                                >
                                    <FaCloudUploadAlt size={24} color={uploading ? '#94a3b8' : '#3b82f6'} />
                                    <span style={{ fontSize: '0.9rem' }}>
                                        {uploading ? 'Subiendo...' : 'Click para subir certificado base (PDF o Imagen)'}
                                    </span>
                                </label>
                            </div>
                        )}
                    </div>
                ) : (
                    <textarea
                        className="infoField"
                        name="valor"
                        style={{ minHeight: '150px', fontFamily: 'monospace', paddingTop: '10px' }}
                        value={form.valor}
                        onChange={handleChange}
                        placeholder="Valor de la configuración..."
                    />
                )}
            </div>


        </div>
    );

    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.6rem',
                marginTop: '.8rem',
                paddingRight: 16,
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={handleSubmit}
                disabled={!form.nombre}
                style={{
                    opacity: !form.nombre ? 0.5 : 1,
                    cursor: !form.nombre ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    return (
        <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {Header}
            {Body}
            {Footer}
        </div>
    );
}
